import { createStore } from '@vfde-sails/core';
import './style.scss';
import app from './container/App';

createStore({});

app();
